import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  List,
  ListItem,
  ListIcon,
  OrderedList,
} from "@chakra-ui/react";
import { FaCheckCircle } from "react-icons/fa";
import { NavbarWithCallToAction } from "../components/chakra/NavbarWithCallToAction/NavbarWithCallToAction";
import { FooterWithFourColumns } from "../components/chakra/FooterWithFourColumns/FooterWithFourColumns";
import { getColor } from "../brandConfig";

const PromotionalTermsPage = () => {
  return (
    <>
      <NavbarWithCallToAction />

      <Box
        bg={getColor("background.main")}
        minHeight="100vh"
        position="relative"
        overflow="hidden"
        _before={{
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: `
            radial-gradient(60% 60% at 0% 0%, #112334 0%, transparent 50%),
            radial-gradient(50% 50% at 50% 50%, #369eff33 0%, transparent 100%)
          `,
          pointerEvents: 'none',
          zIndex: 0,
        }}
        sx={{
          '@keyframes snowfall': {
            '0%': {
              transform: 'translateX(-200px) translateY(-100px)',
              opacity: 0,
            },
            '5%': {
              opacity: 0.4,
            },
            '25%': {
              transform: 'translateX(25vw) translateY(25vh)',
              opacity: 0.8,
            },
            '50%': {
              transform: 'translateX(50vw) translateY(50vh)',
              opacity: 1,
            },
            '75%': {
              transform: 'translateX(75vw) translateY(75vh)',
              opacity: 0.8,
            },
            '95%': {
              opacity: 0.4,
            },
            '100%': {
              transform: 'translateX(calc(100vw + 200px)) translateY(100vh)',
              opacity: 0,
            }
          },
          '@keyframes snowfall-slow': {
            '0%': {
              transform: 'translateX(-250px) translateY(-100px)',
              opacity: 0,
            },
            '5%': {
              opacity: 0.3,
            },
            '30%': {
              transform: 'translateX(35vw) translateY(30vh)',
              opacity: 0.6,
            },
            '60%': {
              transform: 'translateX(65vw) translateY(60vh)',
              opacity: 0.8,
            },
            '95%': {
              opacity: 0.3,
            },
            '100%': {
              transform: 'translateX(calc(100vw + 250px)) translateY(100vh)',
              opacity: 0,
            }
          },
          '@keyframes snowfall-medium': {
            '0%': {
              transform: 'translateX(-180px) translateY(-100px)',
              opacity: 0,
            },
            '8%': {
              opacity: 0.5,
            },
            '40%': {
              transform: 'translateX(45vw) translateY(40vh)',
              opacity: 0.9,
            },
            '70%': {
              transform: 'translateX(80vw) translateY(70vh)',
              opacity: 0.7,
            },
            '92%': {
              opacity: 0.4,
            },
            '100%': {
              transform: 'translateX(calc(100vw + 180px)) translateY(100vh)',
              opacity: 0,
            }
          },
          '&::after': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: '-10%',
            width: '120%',
            height: '100%',
            backgroundImage: `
              radial-gradient(3px 3px at 10% 10%, rgba(255,255,255,0.6) 50%, transparent 50%),
              radial-gradient(4px 4px at 20% 30%, rgba(255,255,255,0.5) 50%, transparent 50%),
              radial-gradient(2px 2px at 15% 50%, rgba(255,255,255,0.7) 50%, transparent 50%),
              radial-gradient(5px 5px at 25% 20%, rgba(255,255,255,0.4) 50%, transparent 50%),
              radial-gradient(3px 3px at 30% 60%, rgba(255,255,255,0.6) 50%, transparent 50%),
              radial-gradient(6px 6px at 35% 40%, rgba(255,255,255,0.3) 50%, transparent 50%),
              radial-gradient(4px 4px at 40% 70%, rgba(255,255,255,0.5) 50%, transparent 50%),
              radial-gradient(2px 2px at 45% 15%, rgba(255,255,255,0.8) 50%, transparent 50%),
              radial-gradient(5px 5px at 50% 80%, rgba(255,255,255,0.4) 50%, transparent 50%)
            `,
            backgroundSize: '400px 400px, 500px 500px, 350px 350px, 450px 450px, 550px 550px, 600px 600px, 480px 480px, 420px 420px, 520px 520px',
            backgroundPosition: '0 0, 80px 60px, 160px 40px, 240px 100px, 320px 160px, 400px 80px, 480px 200px, 560px 20px, 640px 180px',
            animation: 'snowfall 25s linear infinite',
            pointerEvents: 'none',
            zIndex: 1,
          }
        }}
      >
        {/* Snow effect layers */}
        <Box
          position="absolute"
          top={0}
          left={0}
          right={0}
          bottom={0}
          pointerEvents="none"
          zIndex={1}
        >
          <Box
            position="absolute"
            top={0}
            left="-20%"
            width="140%"
            height="100%"
            opacity={0.6}
            sx={{
              backgroundImage: `
                radial-gradient(5px 5px at 5% 15%, rgba(255,255,255,0.4) 50%, transparent 50%),
                radial-gradient(3px 3px at 15% 35%, rgba(255,255,255,0.5) 50%, transparent 50%),
                radial-gradient(7px 7px at 10% 55%, rgba(255,255,255,0.3) 50%, transparent 50%),
                radial-gradient(4px 4px at 20% 25%, rgba(255,255,255,0.6) 50%, transparent 50%),
                radial-gradient(8px 8px at 25% 45%, rgba(255,255,255,0.25) 50%, transparent 50%),
                radial-gradient(6px 6px at 30% 65%, rgba(255,255,255,0.45) 50%, transparent 50%),
                radial-gradient(3px 3px at 35% 20%, rgba(255,255,255,0.7) 50%, transparent 50%)
              `,
              backgroundSize: '600px 600px, 700px 700px, 550px 550px, 650px 650px, 750px 750px, 680px 680px, 580px 580px',
              backgroundPosition: '0 0, 120px 140px, 240px 80px, 360px 200px, 480px 280px, 600px 120px, 720px 40px',
              animation: 'snowfall-slow 35s linear infinite',
            }}
          />

          <Box
            position="absolute"
            top={0}
            left="-15%"
            width="130%"
            height="100%"
            opacity={0.5}
            sx={{
              backgroundImage: `
                radial-gradient(4px 4px at 8% 20%, rgba(255,255,255,0.5) 50%, transparent 50%),
                radial-gradient(6px 6px at 18% 40%, rgba(255,255,255,0.35) 50%, transparent 50%),
                radial-gradient(3px 3px at 12% 60%, rgba(255,255,255,0.6) 50%, transparent 50%),
                radial-gradient(5px 5px at 22% 30%, rgba(255,255,255,0.4) 50%, transparent 50%),
                radial-gradient(7px 7px at 28% 50%, rgba(255,255,255,0.3) 50%, transparent 50%),
                radial-gradient(4px 4px at 32% 70%, rgba(255,255,255,0.55) 50%, transparent 50%)
              `,
              backgroundSize: '550px 550px, 650px 650px, 500px 500px, 600px 600px, 700px 700px, 580px 580px',
              backgroundPosition: '50px 30px, 150px 150px, 250px 90px, 350px 210px, 450px 270px, 550px 150px',
              animation: 'snowfall-medium 30s linear infinite',
            }}
          />
        </Box>

        {/* Hero Section */}
        <Box
          position="relative"
          width="100vw"
          height="400px"
          overflow="hidden"
          marginLeft="50%"
          transform="translateX(-50%)"
          backgroundImage="url('/assets/onesolarimages/abouthero.jpg')"
          backgroundSize="cover"
          backgroundPosition="center"
          backgroundRepeat="no-repeat"
        >
          <Box
            position="absolute"
            top={0}
            left={0}
            right={0}
            bottom={0}
            bg="rgba(0, 0, 0, 0.6)"
            zIndex={1}
          />

          <Container
            maxW="1200px"
            position="relative"
            zIndex={2}
            height="100%"
            display="flex"
            alignItems="center"
          >
            <Box
              width="100%"
              textAlign="center"
              color="white"
            >
              <Heading
                as="h1"
                fontSize={{ base: "3xl", md: "4xl", lg: "5xl" }}
                fontWeight="bold"
                textShadow="2px 2px 4px rgba(0,0,0,0.5)"
                fontFamily="'Open Sans', sans-serif"
                textTransform="uppercase"
              >
                Promotional Terms & Conditions
              </Heading>
            </Box>
          </Container>
        </Box>

        {/* Main Content Section */}
        <Box
          bg="white"
          py={{ base: 16, md: 20 }}
          position="relative"
          zIndex={2}
        >
          <Container maxW="900px">
            <VStack spacing={10} align="stretch">
              {/* Last Updated */}
              <Box>
                <Text
                  fontSize={{ base: "sm", md: "md" }}
                  color="#666"
                  fontFamily="'Open Sans', sans-serif"
                  fontStyle="italic"
                >
                  Last Updated: December 2024
                </Text>
              </Box>

              {/* Introduction */}
              <Box>
                <Text
                  fontSize={{ base: "md", md: "lg" }}
                  color="#666"
                  fontFamily="'Open Sans', sans-serif"
                  lineHeight="1.8"
                >
                  The following terms and conditions apply to all promotional offers, competitions, and special deals provided by One Solar New Zealand. By participating in any promotion, you agree to be bound by these terms.
                </Text>
              </Box>

              {/* Solar Packages Disclaimer */}
              <Box>
                <Box width="60px" height="2px" bg="#121c47" mb={4} />
                <Heading
                  as="h2"
                  fontSize={{ base: "2xl", md: "3xl" }}
                  fontWeight="bold"
                  color="#050303"
                  fontFamily="'Open Sans', sans-serif"
                  mb={4}
                >
                  Solar Packages Disclaimer
                </Heading>

                <Text
                  fontSize={{ base: "md", md: "lg" }}
                  color="#666"
                  fontFamily="'Open Sans', sans-serif"
                  lineHeight="1.8"
                  mb={4}
                >
                  All advertised prices are "starting from" prices and are indicative only. Final costs may vary based on a range of site-specific factors and individual requirements. Pricing variations may occur due to:
                </Text>

                <List spacing={3} ml={6}>
                  <ListItem>
                    <ListIcon as={FaCheckCircle} color="#121c47" />
                    <Text as="span" fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif">
                      <strong>Installation complexity:</strong> Multi-storey buildings, roof type and condition, cable run lengths, and access requirements
                    </Text>
                  </ListItem>
                  <ListItem>
                    <ListIcon as={FaCheckCircle} color="#121c47" />
                    <Text as="span" fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif">
                      <strong>Finance charges:</strong> If applicable to your payment plan
                    </Text>
                  </ListItem>
                  <ListItem>
                    <ListIcon as={FaCheckCircle} color="#121c47" />
                    <Text as="span" fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif">
                      <strong>Electrical requirements:</strong> Single-phase vs. three-phase power systems
                    </Text>
                  </ListItem>
                  <ListItem>
                    <ListIcon as={FaCheckCircle} color="#121c47" />
                    <Text as="span" fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif">
                      <strong>Infrastructure upgrades:</strong> Necessary electrical or structural modifications
                    </Text>
                  </ListItem>
                  <ListItem>
                    <ListIcon as={FaCheckCircle} color="#121c47" />
                    <Text as="span" fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif">
                      <strong>Hazardous materials:</strong> Handling and disposal of asbestos or other hazardous materials
                    </Text>
                  </ListItem>
                  <ListItem>
                    <ListIcon as={FaCheckCircle} color="#121c47" />
                    <Text as="span" fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif">
                      <strong>Access challenges:</strong> Requirements for scaffolding, cranes, or specialized equipment
                    </Text>
                  </ListItem>
                  <ListItem>
                    <ListIcon as={FaCheckCircle} color="#121c47" />
                    <Text as="span" fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif">
                      <strong>Regional location:</strong> Standard pricing based on installations within 100km of our Hamilton office; additional travel costs may apply for remote locations
                    </Text>
                  </ListItem>
                  <ListItem>
                    <ListIcon as={FaCheckCircle} color="#121c47" />
                    <Text as="span" fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif">
                      <strong>Regulatory compliance:</strong> Council fees, building consents, and other regulatory requirements
                    </Text>
                  </ListItem>
                </List>

                <Text
                  fontSize={{ base: "md", md: "lg" }}
                  color="#666"
                  fontFamily="'Open Sans', sans-serif"
                  lineHeight="1.8"
                  mt={4}
                >
                  A comprehensive site assessment will be conducted to provide you with an accurate, personalized quote before any work commences.
                </Text>
              </Box>

              {/* Cash Back Promotions */}
              <Box>
                <Box width="60px" height="2px" bg="#121c47" mb={4} />
                <Heading
                  as="h2"
                  fontSize={{ base: "2xl", md: "3xl" }}
                  fontWeight="bold"
                  color="#050303"
                  fontFamily="'Open Sans', sans-serif"
                  mb={4}
                >
                  Cash Back & Gift Card Promotions
                </Heading>

                <Text
                  fontSize={{ base: "md", md: "lg" }}
                  color="#666"
                  fontFamily="'Open Sans', sans-serif"
                  lineHeight="1.8"
                  mb={4}
                >
                  From time to time, One Solar New Zealand may offer cash back incentives or gift card promotions. The following terms apply:
                </Text>

                <Box bg="#f8f9fa" p={6} borderRadius="md" mb={4}>
                  <VStack spacing={3} align="stretch">
                    <Text fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif">
                      <strong>Eligibility:</strong> New customers only
                    </Text>
                    <Text fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif">
                      <strong>Exclusive Offer:</strong> Cannot be combined with other promotions or discounts
                    </Text>
                    <Text fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif">
                      <strong>Redemption:</strong> Must be mentioned at time of quote to claim
                    </Text>
                    <Text fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif">
                      <strong>Payment Timing:</strong> Cash back or gift cards are provided after successful installation and grid connection
                    </Text>
                    <Text fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif">
                      <strong>Variable Amounts:</strong> Offer amounts may vary depending on the specific promotion and solar system size
                    </Text>
                    <Text fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif">
                      <strong>Limited Time:</strong> Offers are time-limited and may be withdrawn at any time
                    </Text>
                  </VStack>
                </Box>

                <Text
                  fontSize={{ base: "md", md: "lg" }}
                  color="#666"
                  fontFamily="'Open Sans', sans-serif"
                  lineHeight="1.8"
                >
                  Personal information collected for promotional purposes is used solely for administering the offer and is handled in accordance with our Privacy Policy.
                </Text>
              </Box>

              {/* Referral Program */}
              <Box>
                <Box width="60px" height="2px" bg="#121c47" mb={4} />
                <Heading
                  as="h2"
                  fontSize={{ base: "2xl", md: "3xl" }}
                  fontWeight="bold"
                  color="#050303"
                  fontFamily="'Open Sans', sans-serif"
                  mb={4}
                >
                  Referral Bonus Program
                </Heading>

                <Text
                  fontSize={{ base: "md", md: "lg" }}
                  color="#666"
                  fontFamily="'Open Sans', sans-serif"
                  lineHeight="1.8"
                  mb={4}
                >
                  One Solar New Zealand offers referral bonuses to existing customers who refer new customers to our services. This program is part of our One Rewards loyalty initiative.
                </Text>

                <Heading
                  as="h3"
                  fontSize={{ base: "lg", md: "xl" }}
                  fontWeight="bold"
                  color="#050303"
                  fontFamily="'Open Sans', sans-serif"
                  mb={3}
                >
                  Residential Referrals
                </Heading>

                <List spacing={2} ml={6} mb={4}>
                  <ListItem>
                    <ListIcon as={FaCheckCircle} color="#121c47" />
                    <Text as="span" fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif">
                      Referral bonus paid to referring customer upon successful installation and payment
                    </Text>
                  </ListItem>
                  <ListItem>
                    <ListIcon as={FaCheckCircle} color="#121c47" />
                    <Text as="span" fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif">
                      Bonus amount varies based on current promotional offers
                    </Text>
                  </ListItem>
                  <ListItem>
                    <ListIcon as={FaCheckCircle} color="#121c47" />
                    <Text as="span" fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif">
                      Referred customer must be a new client with no prior engagement with One Solar NZ
                    </Text>
                  </ListItem>
                </List>

                <Heading
                  as="h3"
                  fontSize={{ base: "lg", md: "xl" }}
                  fontWeight="bold"
                  color="#050303"
                  fontFamily="'Open Sans', sans-serif"
                  mb={3}
                >
                  Commercial Referrals
                </Heading>

                <List spacing={2} ml={6}>
                  <ListItem>
                    <ListIcon as={FaCheckCircle} color="#121c47" />
                    <Text as="span" fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif">
                      Higher bonus amounts for commercial solar system referrals (typically $500 - $1,000)
                    </Text>
                  </ListItem>
                  <ListItem>
                    <ListIcon as={FaCheckCircle} color="#121c47" />
                    <Text as="span" fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif">
                      Bonus paid upon successful installation, grid connection, and payment in full
                    </Text>
                  </ListItem>
                  <ListItem>
                    <ListIcon as={FaCheckCircle} color="#121c47" />
                    <Text as="span" fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif">
                      Exact bonus amount determined by system size and final contract value
                    </Text>
                  </ListItem>
                </List>
              </Box>

              {/* Social Media Competitions */}
              <Box>
                <Box width="60px" height="2px" bg="#121c47" mb={4} />
                <Heading
                  as="h2"
                  fontSize={{ base: "2xl", md: "3xl" }}
                  fontWeight="bold"
                  color="#050303"
                  fontFamily="'Open Sans', sans-serif"
                  mb={4}
                >
                  Social Media Competitions
                </Heading>

                <Text
                  fontSize={{ base: "md", md: "lg" }}
                  color="#666"
                  fontFamily="'Open Sans', sans-serif"
                  lineHeight="1.8"
                  mb={4}
                >
                  One Solar New Zealand periodically runs competitions and giveaways on our social media platforms. The following general terms apply:
                </Text>

                <List spacing={3} ml={6}>
                  <ListItem>
                    <ListIcon as={FaCheckCircle} color="#121c47" />
                    <Text as="span" fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif">
                      <strong>Eligibility:</strong> New Zealand residents only, unless otherwise specified
                    </Text>
                  </ListItem>
                  <ListItem>
                    <ListIcon as={FaCheckCircle} color="#121c47" />
                    <Text as="span" fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif">
                      <strong>Entry Limit:</strong> One entry per person/profile, unless otherwise stated
                    </Text>
                  </ListItem>
                  <ListItem>
                    <ListIcon as={FaCheckCircle} color="#121c47" />
                    <Text as="span" fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif">
                      <strong>Winner Selection:</strong> Winners chosen randomly or based on specific criteria outlined in the competition post
                    </Text>
                  </ListItem>
                  <ListItem>
                    <ListIcon as={FaCheckCircle} color="#121c47" />
                    <Text as="span" fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif">
                      <strong>Winner Notification:</strong> Winners will be notified via the platform where the competition was held
                    </Text>
                  </ListItem>
                  <ListItem>
                    <ListIcon as={FaCheckCircle} color="#121c47" />
                    <Text as="span" fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif">
                      <strong>Prize Fulfillment:</strong> Prizes will be distributed within 30 days of winner announcement
                    </Text>
                  </ListItem>
                  <ListItem>
                    <ListIcon as={FaCheckCircle} color="#121c47" />
                    <Text as="span" fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif">
                      <strong>No Cash Alternative:</strong> Prizes are non-transferable and cannot be exchanged for cash
                    </Text>
                  </ListItem>
                </List>

                <Text
                  fontSize={{ base: "md", md: "lg" }}
                  color="#666"
                  fontFamily="'Open Sans', sans-serif"
                  lineHeight="1.8"
                  mt={4}
                >
                  Personal information collected through competitions is used solely for competition administration and prize fulfillment, in accordance with our Privacy Policy.
                </Text>
              </Box>

              {/* General Conditions */}
              <Box>
                <Box width="60px" height="2px" bg="#121c47" mb={4} />
                <Heading
                  as="h2"
                  fontSize={{ base: "2xl", md: "3xl" }}
                  fontWeight="bold"
                  color="#050303"
                  fontFamily="'Open Sans', sans-serif"
                  mb={4}
                >
                  General Conditions
                </Heading>

                <VStack spacing={6} align="stretch">
                  <Box>
                    <Heading
                      as="h3"
                      fontSize={{ base: "lg", md: "xl" }}
                      fontWeight="bold"
                      color="#050303"
                      fontFamily="'Open Sans', sans-serif"
                      mb={3}
                    >
                      1. Promotion Changes
                    </Heading>
                    <Text
                      fontSize={{ base: "md", md: "lg" }}
                      color="#666"
                      fontFamily="'Open Sans', sans-serif"
                      lineHeight="1.8"
                    >
                      One Solar New Zealand reserves the right to modify, suspend, or terminate any promotion at any time without prior notice. This includes the right to change offer amounts, eligibility criteria, and promotional periods.
                    </Text>
                  </Box>

                  <Box>
                    <Heading
                      as="h3"
                      fontSize={{ base: "lg", md: "xl" }}
                      fontWeight="bold"
                      color="#050303"
                      fontFamily="'Open Sans', sans-serif"
                      mb={3}
                    >
                      2. Verification Rights
                    </Heading>
                    <Text
                      fontSize={{ base: "md", md: "lg" }}
                      color="#666"
                      fontFamily="'Open Sans', sans-serif"
                      lineHeight="1.8"
                    >
                      We reserve the right to verify all promotional claims and eligibility requirements. Failure to provide requested verification may result in disqualification from the promotion.
                    </Text>
                  </Box>

                  <Box>
                    <Heading
                      as="h3"
                      fontSize={{ base: "lg", md: "xl" }}
                      fontWeight="bold"
                      color="#050303"
                      fontFamily="'Open Sans', sans-serif"
                      mb={3}
                    >
                      3. Fraudulent Activity
                    </Heading>
                    <Text
                      fontSize={{ base: "md", md: "lg" }}
                      color="#666"
                      fontFamily="'Open Sans', sans-serif"
                      lineHeight="1.8"
                    >
                      Any fraudulent, duplicate, or suspicious entries or claims will be disqualified. We reserve the right to take legal action if necessary.
                    </Text>
                  </Box>

                  <Box>
                    <Heading
                      as="h3"
                      fontSize={{ base: "lg", md: "xl" }}
                      fontWeight="bold"
                      color="#050303"
                      fontFamily="'Open Sans', sans-serif"
                      mb={3}
                    >
                      4. Liability
                    </Heading>
                    <Text
                      fontSize={{ base: "md", md: "lg" }}
                      color="#666"
                      fontFamily="'Open Sans', sans-serif"
                      lineHeight="1.8"
                    >
                      One Solar New Zealand is not responsible for lost, late, incomplete, or misdirected entries or claims. We are not liable for any technical failures, interruptions, or errors that may affect participation in any promotion.
                    </Text>
                  </Box>

                  <Box>
                    <Heading
                      as="h3"
                      fontSize={{ base: "lg", md: "xl" }}
                      fontWeight="bold"
                      color="#050303"
                      fontFamily="'Open Sans', sans-serif"
                      mb={3}
                    >
                      5. Tax Obligations
                    </Heading>
                    <Text
                      fontSize={{ base: "md", md: "lg" }}
                      color="#666"
                      fontFamily="'Open Sans', sans-serif"
                      lineHeight="1.8"
                    >
                      Winners of prizes or promotional benefits are responsible for any applicable taxes or duties. We recommend consulting with a tax professional regarding any tax implications.
                    </Text>
                  </Box>

                  <Box>
                    <Heading
                      as="h3"
                      fontSize={{ base: "lg", md: "xl" }}
                      fontWeight="bold"
                      color="#050303"
                      fontFamily="'Open Sans', sans-serif"
                      mb={3}
                    >
                      6. Privacy
                    </Heading>
                    <Text
                      fontSize={{ base: "md", md: "lg" }}
                      color="#666"
                      fontFamily="'Open Sans', sans-serif"
                      lineHeight="1.8"
                    >
                      All personal information collected through promotional activities is handled in accordance with our Privacy Policy. By participating in any promotion, you consent to the collection, use, and disclosure of your information as described in the Privacy Policy.
                    </Text>
                  </Box>

                  <Box>
                    <Heading
                      as="h3"
                      fontSize={{ base: "lg", md: "xl" }}
                      fontWeight="bold"
                      color="#050303"
                      fontFamily="'Open Sans', sans-serif"
                      mb={3}
                    >
                      7. Governing Law
                    </Heading>
                    <Text
                      fontSize={{ base: "md", md: "lg" }}
                      color="#666"
                      fontFamily="'Open Sans', sans-serif"
                      lineHeight="1.8"
                    >
                      These promotional terms and conditions are governed by the laws of New Zealand. Any disputes arising from promotional activities will be subject to the exclusive jurisdiction of New Zealand courts.
                    </Text>
                  </Box>
                </VStack>
              </Box>

              {/* Contact Information */}
              <Box bg="#f8f9fa" p={8} borderRadius="lg">
                <Heading
                  as="h2"
                  fontSize={{ base: "xl", md: "2xl" }}
                  fontWeight="bold"
                  color="#050303"
                  fontFamily="'Open Sans', sans-serif"
                  mb={4}
                >
                  Questions About Our Promotions?
                </Heading>
                <Text
                  fontSize={{ base: "md", md: "lg" }}
                  color="#666"
                  fontFamily="'Open Sans', sans-serif"
                  lineHeight="1.8"
                  mb={4}
                >
                  If you have any questions about our promotional terms and conditions, please contact us:
                </Text>
                <VStack align="stretch" spacing={2}>
                  <Text fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif">
                    <strong>Email:</strong> hello@onesolarnz.co.nz
                  </Text>
                  <Text fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif">
                    <strong>Phone:</strong> 0800 767 024
                  </Text>
                  <Text fontSize={{ base: "md", md: "lg" }} color="#666" fontFamily="'Open Sans', sans-serif">
                    <strong>Address:</strong> 21c Somerset Street, Frankton, Hamilton, New Zealand
                  </Text>
                </VStack>
              </Box>

              {/* Important Notice */}
              <Box
                bg="#121c47"
                color="white"
                p={6}
                borderRadius="lg"
              >
                <Text
                  fontSize={{ base: "md", md: "lg" }}
                  fontFamily="'Open Sans', sans-serif"
                  lineHeight="1.8"
                  fontWeight="600"
                >
                  By participating in any One Solar New Zealand promotion, you acknowledge that you have read, understood, and agree to be bound by these Promotional Terms & Conditions.
                </Text>
              </Box>
            </VStack>
          </Container>
        </Box>

        <FooterWithFourColumns />
      </Box>
    </>
  );
};

export default PromotionalTermsPage;
